export const uk = {
    'try-later': 'Произошла ошибка, попробуйте еще раз'
};
